import Vue from 'vue'
import App from './App.vue'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import './assets/iconfont/iconfont.css'
import currency from '@/assets/js/currency';

Vue.use(MintUI)
//全局方法
Vue.use(currency)

Vue.config.productionTip = false
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
